<script setup>
  import { ref, onMounted } from 'vue';

  import { useSpotStore } from "@/stores/SpotStore";

  import useLegacyBridge from "@/composables/useLegacyBridge";

  const content = defineModel('content');

  const spotStore = useSpotStore();

  const { stats } = useLegacyBridge();

  const contentContainer = ref(null);
  
  function loadStats() {
    const settings = {
      spotId: spotStore.spotId,
    }       
    
    content.value = stats(contentContainer.value, settings);
  }

  onMounted(() => loadStats());
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>